import i18n from '@/i18n'

function setCurrency() {
    return 'zł'
}

export default function(key) {
    const currency = setCurrency()
    return i18n.t(key).replace('{currency}', currency)
}
